import Calendar from 'src/views/apps/schedule'

const Schedule = () => (<Calendar />);

export default Schedule;